export const splashImages = [
  // iPhone 5, 5S, 5C and 5SE
  {
    image: 'splash-screen-640x1136.jpg',
    media: '(device-width: 320px) and (device-height: 568px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)',
  },
  // iPhone 6, 6S, 7 and 8
  {
    image: 'splash-screen-750x1294.jpg',
    media: '(device-width: 375px) and (device-height: 667px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)',
  },
  // iPhone 6+, 7+ and 8+
  {
    image: 'splash-screen-1242x2148.jpg',
    media: '(device-width: 414px) and (device-height: 736px) and (-webkit-device-pixel-ratio: 3) and (orientation: portrait)',
  },
  // iPhone X
  {
    image: 'splash-screen-1125x2436.jpg',
    media: '(device-width: 375px) and (device-height: 812px) and (-webkit-device-pixel-ratio: 3) and (orientation: portrait)',
  },
  // iPad 3, 4 and Pro 9.7"
  {
    image: 'splash-screen-1536x2048.jpg',
    media: '(min-device-width: 768px) and (max-device-width: 1024px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait)',
  },
  // iPad Pro 10.5"
  {
    image: 'splash-screen-1668x2224.jpg',
    media: '(min-device-width: 834px) and (max-device-width: 834px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait)',
  },
  // iPad Pro 12.9"
  {
    image: 'splash-screen-2048x2732.jpg',
    media: '(min-device-width: 1024px) and (max-device-width: 1024px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait)',
  },
];
